/* eslint-disable */
export class UserInfo {
    uid: string;
    name: string;
    last_name: string;
    email: string;
    phone: string;
    company: string;
    temporary: boolean;
    new_user: boolean;
    expires: string;
    accounts: number;
    free: boolean;
    subscription_id?: string;
    notify?: boolean;
    directory?: boolean;
    last_org_id?: string;
    last_group_id?: string;
    last_document_id?: string;    
    last_login?: string;
    last_logout?: string;
    failed_logins?: number;
}
